import BaseFactory from 'services/sports/default/base-factory';
import Lineup from './lineup';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new Lineup(params);
    }
}

export {Factory};
